export const COLUMNS = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  key: '1',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'index'
  }
}, {
  slots: {
    title: '统计机构'
  },
  dataIndex: 'organizationName',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '财产保险（万元）'
  },
  dataIndex: 'property',
  key: '3',
  align: 'center'
}, {
  slots: {
    title: '人身保险（万元）'
  },
  dataIndex: 'personal',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '合计（万元）'
  },
  dataIndex: 'total',
  key: '5',
  align: 'center'
}];
export const data = [{
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  property: '234',
  total: '312',
  personal: '78',
  id: '1'
}, {
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  property: '234',
  total: '312',
  personal: '78',
  id: '2'
}];